interface EventRow {
  moment: string;
  meta: string;
  reddit: string;
  ga4: string;
  googleAds: string;
}

const NOT_SENT = '—';

const EVENT_ROWS: EventRow[] = [
  { moment: 'Game opened', meta: 'PageView', reddit: 'PageVisit', ga4: 'page_view', googleAds: NOT_SENT },
  { moment: 'Pack page shown', meta: 'ViewContent', reddit: 'ViewContent', ga4: 'view_item', googleAds: NOT_SENT },
  {
    moment: 'Buy pressed',
    meta: 'InitiateCheckout',
    reddit: 'AddToCart',
    ga4: 'begin_checkout',
    googleAds: 'Checkout label, if set',
  },
  { moment: 'Purchase completed', meta: 'Purchase', reddit: 'Purchase', ga4: 'purchase', googleAds: 'Purchase label' },
];

const CELL = 'border-b border-[var(--co-border)] px-2 py-1.5 text-left';

export function EventsTable() {
  return (
    <section className="rounded-xl border border-[var(--co-border)] bg-[var(--co-surface)] p-4 text-[12px] text-[var(--co-muted)]">
      <p className="mb-2 font-semibold text-[var(--co-text)]">What the game sends</p>
      <table className="w-full border-collapse">
        <thead className="text-[var(--co-text)]">
          <tr>
            <th className={CELL}>When</th>
            <th className={CELL}>Meta</th>
            <th className={CELL}>Reddit</th>
            <th className={CELL}>GA4</th>
            <th className={CELL}>Google Ads</th>
          </tr>
        </thead>
        <tbody className="font-mono">
          {EVENT_ROWS.map((row) => (
            <tr key={row.moment}>
              <td className={`${CELL} font-sans text-[var(--co-text)]`}>{row.moment}</td>
              <td className={CELL}>{row.meta}</td>
              <td className={CELL}>{row.reddit}</td>
              <td className={CELL}>{row.ga4}</td>
              <td className={`${CELL} font-sans`}>{row.googleAds}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="mt-2">
        Pack, checkout and purchase events carry the pack id and name, quantity, amount and currency. Each purchase is
        sent once, with its order id.
      </p>
    </section>
  );
}
